import RolesEnum from "../../Enum/RolesEnum"
import { getUser } from "../../services/UserService"
import { isBackOfficeOrUpgasEmployee } from "../../services/UserService"
import ChatMenu from "../../components/sidebar/ChatMenu"
import {MenusFuncionarioEnum} from "../../Enum/MenuFuncionarioEnum";

const { BackOffice, FuncionarioUpgas, Organizacao } = RolesEnum

export default (organizationResales) => {
  const { role } = getUser()
  const menus = [
    {
      key: '1',
      menuEnum: MenusFuncionarioEnum.Dashboard,
      url: '/dashboard',
      icon: 'dashboard',
      text: 'Dashboard',
      roles: [BackOffice, FuncionarioUpgas, Organizacao],
      childs: []
    },
    {
      key: '2',
      menuEnum: MenusFuncionarioEnum.Pedidos,
      url: '/dashboard/operacao',
      icon: 'stock',
      text: 'Pedidos',
      roles: [BackOffice, FuncionarioUpgas, Organizacao],
      childs: []
    },
    {
      key: '3',
      menuEnum: MenusFuncionarioEnum.Chat,
      url: '/chat',
      icon: 'message',
      text: 'Chat',
      roles: [BackOffice, FuncionarioUpgas, Organizacao],
      childs: [],
      component: isBackOfficeOrUpgasEmployee() ? ChatMenu : null
    },
    {
      key: '4',
      menuEnum: MenusFuncionarioEnum.Revendas,
      url: isBackOfficeOrUpgasEmployee() ? '/revendas/list/1' : `/revendas/${organizationResales[0]?.id}/edit`,
      icon: isBackOfficeOrUpgasEmployee() ? 'bank' : 'setting',
      text: isBackOfficeOrUpgasEmployee() ? 'Revendas' : 'Preços e Horários',
      roles: [BackOffice, FuncionarioUpgas, Organizacao],
      disabled: role === Organizacao && !organizationResales.length,
      childs: []
    },
    {
      key: '5',
      menuEnum: MenusFuncionarioEnum.Pedidos,
      url: '/pedidos',
      icon: 'container',
      text: 'Histórico de Pedidos',
      roles: [Organizacao],
      childs: []
    },
    {
      key: '7',
      url: '/motoristas',
      icon: 'car',
      text: 'Motoristas',
      roles: [Organizacao],
      childs: []
    },
    {
      key: '8',
      url: '/usuarios',
      icon: 'user',
      text: 'Usuários',
      roles: [BackOffice, FuncionarioUpgas],
      childs: []
    },
    /** deprecated
    {
      key: '10',
      propAction: 'openProfile',
      url: '/revendas',
      icon: 'setting',
      text: 'Preços e Horários',
      roles: [FuncionarioRevenda],
      childs: []
    },
    {
      key: '11',
      propAction: 'openUserProfile',
      url: '',
      icon: 'setting',
      text: 'Meu Perfil',
      roles: [FuncionarioRevenda],
      notSelectable: true,
      childs: []
    },
     **/
    {
      key: '12',
      menuEnum: MenusFuncionarioEnum.Configuracoes,
      propAction: 'openConfig',
      url: '',
      icon: 'heat-map',
      text: 'Configurações',
      roles: [BackOffice, FuncionarioUpgas],
      childs: []
    },
    {
      key: '13',
      menuEnum: MenusFuncionarioEnum.Relatorios,
      url: '',
      icon: 'table',
      text: 'Relatórios',
      roles: [BackOffice, FuncionarioUpgas],
      childs: [
        {
          key: '14',
          url: '/relatorios/motoristas',
          icon: 'car',
          text: 'Relatório Motoristas',
          roles: [BackOffice, FuncionarioUpgas],
          childs: []
        },
        {
          key: '16',
          url: '/relatorios/revendas',
          icon: 'bank',
          text: 'Relatório Revendas',
          roles: [BackOffice, FuncionarioUpgas],
          childs: []
        },
        {
          key: '17',
          url: '/relatorios/pedidos',
          icon: 'bank',
          text: 'Relatório Pedidos',
          roles: [BackOffice, FuncionarioUpgas],
          childs: []
        }
      ]
    },
    {
      key: '18',
      menuEnum: MenusFuncionarioEnum.Financas,
      url: '',
      icon: 'dollar',
      text: 'Finanças',
      roles: [BackOffice, FuncionarioUpgas, Organizacao],
      childs: [
        {
          key: '18.1',
          url: '/financas/pedidos',
          icon: 'container',
          text: 'Pedidos',
          roles: [BackOffice, FuncionarioUpgas, Organizacao],
          childs: []
        },
        {
          key: '18.2',
          url: '/financas/balancos',
          icon: 'container',
          text: 'Balanços',
          roles: [BackOffice, FuncionarioUpgas, Organizacao],
          childs: []
        }
      ]
    },
    {
      key: '19',
      menuEnum: MenusFuncionarioEnum.Organizacoes,
      url: '/organizacoes',
      icon: 'cluster',
      text: 'Organizações',
      roles: [BackOffice, FuncionarioUpgas],
      childs: []
    },
    {
      key: '20',
      menuEnum: MenusFuncionarioEnum.QuadroDeAvisos,
      url: '/quadroDeAvisos',
      icon: 'sound',
      text: 'Quadros de Aviso',
      roles: [BackOffice, FuncionarioUpgas],
      childs: []
    },
    {
      key: '21',
      url: '/termos-condicoes',
      icon: 'file-zip',
      text: 'Termos e Condições',
      roles: [Organizacao],
      childs: [],
    },
    {
      key: '22',
      menuEnum: MenusFuncionarioEnum.Cupons,
      url: '/cupons',
      icon: 'tag',
      text: 'Cupons',
      roles: [BackOffice, FuncionarioUpgas],
      childs: [],
    },
    {
      key: '23',
      menuEnum: MenusFuncionarioEnum.Desempenho,
      url: '/desempenho',
      icon: 'bar-chart',
      text: 'Desempenho',
      roles: [BackOffice, FuncionarioUpgas, Organizacao],
      childs: [],
    },
    {
      key: '24',
      menuEnum: MenusFuncionarioEnum.TelefonesBloqueados,
      url: '/telefonesBloqueados',
      icon: 'stop',
      text: 'Telefones Bloqueados',
      roles: [BackOffice, FuncionarioUpgas],
      childs: []
    },
    {
      key: '25',
      menuEnum: MenusFuncionarioEnum.IndiqueGanhe,
      url: '/indiqueGanhe',
      icon: 'like',
      text: 'Indique e Ganhe',
      roles: [BackOffice, FuncionarioUpgas],
      childs: []
    },
  ]

  let menusResult = menus.filter(menu => menu.roles.some(menuRole => menuRole === role))

  menusResult
    .filter(menu => menu.childs.length > 0)
    .forEach(menu => menu.childs = menu.childs.filter(child => child.roles.some(menuRole => menuRole === role)))

  return menusResult
}
